import { useDocumentPictureInPicture } from '@/hooks/useDocumentPictureInPicture';
import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react';

type PictureInPictureModeContextType = {
  isPIPMode: null | boolean;
  setIsPIPMode: (isPIPMode: null | boolean) => void;
  invoiceFileId: string | null;
  setInvoiceFileId: (invoiceFileId: string | null) => void;
  pdfViewerContainerRef: React.RefObject<HTMLDivElement>;
  updatePictureInPictureContent: () => void;
  openPictureInPicture: (value: boolean, onClose?: () => void) => Promise<void>;
};

const Context = createContext<PictureInPictureModeContextType>({
  isPIPMode: null,
  setIsPIPMode: () => {},
  invoiceFileId: '',
  setInvoiceFileId: () => {},
  pdfViewerContainerRef: { current: null },
  updatePictureInPictureContent: () => {},
  openPictureInPicture: () => Promise.resolve(),
});

export const PictureInPictureModeProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [isPIPMode, setIsPIPMode] = useState<null | boolean>(null);
  const [invoiceFileId, setInvoiceFileId] = useState<string | null>('');
  const pdfViewerContainerRef = useRef<HTMLDivElement | null>(null);
  const { updatePictureInPictureContent, openPictureInPicture } =
    useDocumentPictureInPicture(pdfViewerContainerRef);
  const value = useMemo(
    () => ({
      isPIPMode,
      setIsPIPMode,
      invoiceFileId,
      setInvoiceFileId,
      pdfViewerContainerRef,
      updatePictureInPictureContent,
      openPictureInPicture,
    }),
    [
      isPIPMode,
      setIsPIPMode,
      invoiceFileId,
      setInvoiceFileId,
      pdfViewerContainerRef,
      updatePictureInPictureContent,
      openPictureInPicture,
    ]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const usePictureInPictureModeContext = () => useContext(Context);
